import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type NavigationElementClasses =
  | 'item'
  | 'activeItem'
  | 'disabledItem'
  | 'itemNumber'
  | 'completedIcon'
  | 'completedIconVisible'
  | 'deselectedItem'
  | 'completedItem'
  | 'container'
  | 'label'
  | 'modelNameLabel'
  | 'oldItem'
  | 'modelName'
  | 'customiseItem'
  | 'customiseLabel'
  | 'customiseActiveItem';

const navigationElementStyles = makeStyles<ISpcTheme, NavigationElementClasses>(
  theme => ({
    completedIcon: {
      fontSize: theme.typography.fontMD,
      display: 'none',
      fontFamily: theme.typography.fontFamily2,
    },
    completedIconVisible: {
      display: 'block',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    item: {
      display: 'inline-block',
      minWidth: 'fit-content',
      color: theme.palette.common.white,
      padding: `16px 40px 16px 24px`,
      borderRadius: 0,
      borderBottom: `4px solid transparent`,
      [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        width: '33%',
        padding: 4,
        borderWidth: 2,
      },
      '& .MuiButton-label': {
        display: 'flex',
      },
    },
    oldItem: {
      width: 'auto',
      padding: `${theme.spacing(2)} ${theme.spacing(5)} ${theme.spacing(2)} ${theme.spacing(3)}`,
      [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        padding: theme.spacing(0.5),
      },
    },
    itemNumber: {
      margin: `0 4px`,
    },
    activeItem: {
      fontFamily: theme.typography.fontFamily2,
      fontWeight: 'normal',
      borderBottomColor: theme.palette.common.white,
    },
    disabledItem: {
      opacity: 0.5,
      pointerEvents: 'none',
    },
    completedItem: {
      color: theme.palette.common.white,
    },
    deselectedItem: {
      opacity: 0.7,
    },
    container: {
      background: theme.palette.primary.contrastText,
    },
    modelNameLabel: {},
    modelName: {},
    customiseItem: {},
    customiseLabel: {},
    customiseActiveItem: {},
  }),
  { name: 'Customise_NavigationElement' },
);

export default navigationElementStyles;
